// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Selector$SmartcutsMacros = require("../../Selector.bs.js");
var OptionUtils$SmartcutsMacros = require("../../../../bs-utils/src/OptionUtils.bs.js");
var InnerTextSemantic$SmartcutsMacros = require("../../semantics/InnerTextSemantic.bs.js");

function scrollDirection_encode(v) {
  return ["ScrollDown"];
}

function scrollDirection_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "ScrollDown") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* ScrollDown */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringifyScrollDirection(scrollDirection) {
  return "ScrollDown";
}

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "direction",
                ["ScrollDown"]
              ],
              [
                "scrollRoot",
                Selector$SmartcutsMacros.elementSelector_encode(v.scrollRoot)
              ]
            ]);
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var direction = scrollDirection_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "direction"), null));
  if (direction.TAG === /* Ok */0) {
    var scrollRoot = Selector$SmartcutsMacros.elementSelector_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "scrollRoot"), null));
    if (scrollRoot.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                direction: direction._0,
                scrollRoot: scrollRoot._0
              }
            };
    }
    var e = scrollRoot._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".scrollRoot" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = direction._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".direction" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function stringify(param) {
  return "{ direction: ScrollDown, scrollRoot: " + Selector$SmartcutsMacros.stringifyElementSelector(param.scrollRoot);
}

var ScrollAction = {
  t_encode: t_encode,
  t_decode: t_decode,
  stringify: stringify
};

function clickOnElement_encode(v) {
  return Js_dict.fromArray([
              [
                "elementSelector",
                Selector$SmartcutsMacros.elementSelector_encode(v.elementSelector)
              ],
              [
                "maybeInnerTextSemantic",
                Decco.optionToJson(InnerTextSemantic$SmartcutsMacros.t_encode, v.maybeInnerTextSemantic)
              ],
              [
                "maybeScrollToRevealElement",
                Decco.optionToJson(t_encode, v.maybeScrollToRevealElement)
              ]
            ]);
}

function clickOnElement_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var elementSelector = Selector$SmartcutsMacros.elementSelector_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "elementSelector"), null));
  if (elementSelector.TAG === /* Ok */0) {
    var maybeInnerTextSemantic = Decco.optionFromJson(InnerTextSemantic$SmartcutsMacros.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "maybeInnerTextSemantic"), null));
    if (maybeInnerTextSemantic.TAG === /* Ok */0) {
      var maybeScrollToRevealElement = Decco.optionFromJson(t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "maybeScrollToRevealElement"), null));
      if (maybeScrollToRevealElement.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  elementSelector: elementSelector._0,
                  maybeInnerTextSemantic: maybeInnerTextSemantic._0,
                  maybeScrollToRevealElement: maybeScrollToRevealElement._0
                }
              };
      }
      var e = maybeScrollToRevealElement._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".maybeScrollToRevealElement" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = maybeInnerTextSemantic._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".maybeInnerTextSemantic" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = elementSelector._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".elementSelector" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function paginateWithHints_encode(v) {
  if (v.TAG === /* Scroll */0) {
    return [
            "Scroll",
            t_encode(v._0)
          ];
  } else {
    return [
            "ClickOnElement",
            clickOnElement_encode(v._0)
          ];
  }
}

function paginateWithHints_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "ClickOnElement" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = clickOnElement_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* ClickOnElement */1,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "Scroll" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Scroll */0,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function paginateMethod_encode(v) {
  if (v) {
    return [
            "PaginateWithHints",
            paginateWithHints_encode(v._0)
          ];
  } else {
    return ["PaginateByAutoScrolling"];
  }
}

function paginateMethod_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "PaginateByAutoScrolling" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* PaginateByAutoScrolling */0
                  };
          }
      case "PaginateWithHints" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = paginateWithHints_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: /* PaginateWithHints */{
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function loadItems_encode(v) {
  if (typeof v === "number") {
    if (v !== 0) {
      return ["AllItems"];
    } else {
      return ["ItemsOnFirstPage"];
    }
  } else {
    return [
            "NumberOfItems",
            Decco.intToJson(v._0)
          ];
  }
}

function loadItems_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "AllItems" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* AllItems */1
                  };
          }
      case "ItemsOnFirstPage" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* ItemsOnFirstPage */0
                  };
          }
      case "NumberOfItems" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: /* NumberOfItems */{
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function t_encode$1(v) {
  return Js_dict.fromArray([
              [
                "paginateMethod",
                paginateMethod_encode(v.paginateMethod)
              ],
              [
                "loadItems",
                loadItems_encode(v.loadItems)
              ]
            ]);
}

function t_decode$1(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var paginateMethod = paginateMethod_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "paginateMethod"), null));
  if (paginateMethod.TAG === /* Ok */0) {
    var loadItems = loadItems_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "loadItems"), null));
    if (loadItems.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                paginateMethod: paginateMethod._0,
                loadItems: loadItems._0
              }
            };
    }
    var e = loadItems._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".loadItems" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = paginateMethod._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".paginateMethod" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function stringifyClickOnElement(param) {
  return "{ elementSelector: " + (Selector$SmartcutsMacros.stringifyElementSelector(param.elementSelector) + (", maybeInnerTextSemantic: " + (OptionUtils$SmartcutsMacros.stringify(InnerTextSemantic$SmartcutsMacros.stringify, param.maybeInnerTextSemantic) + (", maybeScrollToRevealElement: " + OptionUtils$SmartcutsMacros.stringify(stringify, param.maybeScrollToRevealElement)))));
}

function stringifyPaginateWithHints(paginateWithHints) {
  if (paginateWithHints.TAG === /* Scroll */0) {
    return "Scroll(" + (stringify(paginateWithHints._0) + ")");
  } else {
    return "ClickOnElement(" + (stringifyClickOnElement(paginateWithHints._0) + ")");
  }
}

function stringifyPaginateMethod(paginateMethod) {
  if (paginateMethod) {
    return "PaginateWithHints(" + (stringifyPaginateWithHints(paginateMethod._0) + ")");
  } else {
    return "PaginateByAutoScrolling";
  }
}

function stringifyLoadItems(loadItems) {
  if (typeof loadItems === "number") {
    if (loadItems !== 0) {
      return "AllItems";
    } else {
      return "ItemsOnFirstPage";
    }
  } else {
    return "NumberOfItems(" + (String(loadItems._0) + ")");
  }
}

function stringify$1(param) {
  return "{ paginateMethod: " + (stringifyPaginateMethod(param.paginateMethod) + (", loadItems: " + (stringifyLoadItems(param.loadItems) + " }")));
}

exports.scrollDirection_encode = scrollDirection_encode;
exports.scrollDirection_decode = scrollDirection_decode;
exports.stringifyScrollDirection = stringifyScrollDirection;
exports.ScrollAction = ScrollAction;
exports.clickOnElement_encode = clickOnElement_encode;
exports.clickOnElement_decode = clickOnElement_decode;
exports.paginateWithHints_encode = paginateWithHints_encode;
exports.paginateWithHints_decode = paginateWithHints_decode;
exports.paginateMethod_encode = paginateMethod_encode;
exports.paginateMethod_decode = paginateMethod_decode;
exports.loadItems_encode = loadItems_encode;
exports.loadItems_decode = loadItems_decode;
exports.t_encode = t_encode$1;
exports.t_decode = t_decode$1;
exports.stringifyClickOnElement = stringifyClickOnElement;
exports.stringifyPaginateWithHints = stringifyPaginateWithHints;
exports.stringifyPaginateMethod = stringifyPaginateMethod;
exports.stringifyLoadItems = stringifyLoadItems;
exports.stringify = stringify$1;
/* Selector-SmartcutsMacros Not a pure module */
